import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQueryWithReauth } from './baseQuery'
// Define a service using a base URL and expected endpoints
export const deApi = createApi({
  reducerPath: 'deApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    login: builder.mutation({
      query: ({ email, password }) => ({
        url: `auth/signin`,
        method: 'POST',
        body: { email, password },
      }),
      transformResponse: (response) => {
        if (response?.response?.accessToken) {
          localStorage.setItem('userLoggedIn', true)
          localStorage.setItem(
            'userData',
            JSON.stringify(response.response.data)
          )
          localStorage.setItem('jwtToken', response?.response?.accessToken)
        }
        return response
      },
    }),
    listRoles: builder.query({
      query: (payload) => ({
        url: `role`,
        method: 'GET',
        body: payload,
      }),
    }),
  }),
})

export const { useListUsersMutation } = deApi
